module.exports = __webpack_public_path__ + "img/css_sprites-left-21.1ddfea2.png";